export const API_URL = process.env.REACT_APP_API_URL;

export const END_POINTS = {
  // auth
  login: "/login",
  refreshToken: "/login/token",

  //users
  user: "/admin/user",
  userSearch: "/admin/user-search",
  updateUser: "/admin/update-user-status",

  //dashboard
  dashboard: "/admin/dashboard",

  //notification
  notification: "/notification",
  notificationCount: "/notification/count",
  //posts
  comment: "/admin/comment",
  discussion: "/admin/discussion",
  updateComment: "/admin/updateComment",
  post: "/admin/post",
  addPost: "/admin/post",
  postLike: "/admin/getLike",
  updatePost: "/admin/update-post-status",
  categories: "/admin/category",
  subscription: "/admin/subscription",
  deletePost: "/admin/delete-post",
  getReport: "/admin/report",
  getComment: "/admin/comment",
  addFcm: "/admin/fcm",
  discussionUpdate: "/admin/discussion",
  getcouponcode: "/admin/coupon_code_list",
  createCouponCode: "/admin/create_coupon_code",
  editCouponCode: "/admin/edit_coupon_code",
};
